import { styled } from "@mui/material/styles";
import { Route, Routes } from "react-router-dom";
import { Avatar, Box, Stack, Typography } from "@mui/material";

import { Verify } from "./verify";
import { Balance } from "./balance";
import { Withdraw } from "./withdraw";
import { useGlobalContext } from "../../provider";
import { SettingSidebar } from "./settingSidebar";
import { capitalizeFirstLetter } from "../../utils";
import { Layout } from "../../components/layout/layout";
import { GlobalFirstSection, GlobalSpacing } from "../../components/layout/styles";

const Settings = () => {
	const [globalState]: GlobalContextType = useGlobalContext();

	return (
		<Layout>
			<GlobalSpacing>
				<SettingsWrapper>
					<UserInfoSection>
						<UserAvatar>
							<Avatar src={globalState.userData.image} alt={capitalizeFirstLetter(globalState.userData.name)} />
						</UserAvatar>

						<Stack flex={1} gap={1}>
							<Typography variant="h5">
								{capitalizeFirstLetter(globalState.userData.name)}
							</Typography>

							<Typography typography="body1">
								{globalState.userData.bio}
							</Typography>
						</Stack>
					</UserInfoSection>

					<SectionContainer>
						<SettingSidebar />

						<SettingContent>
							<Routes>
								<Route path='/verify' element={<Verify />} />
								<Route path='/balance' element={<Balance />} />
								<Route path='/withdraw' element={<Withdraw />} />
								<Route path='/*' element={<Verify />} />
							</Routes>
						</SettingContent>
					</SectionContainer>
				</SettingsWrapper>
			</GlobalSpacing>
		</Layout>
	)
}

const SettingsWrapper = styled(GlobalFirstSection)(({ theme }) => ({
	display: 'flex',
	flexDirection: "column",
	gap: theme.spacing(5),
	padding: `${theme.spacing(5)} 0px`,

	[theme.breakpoints.down("md")]: {
		gap: theme.spacing(3),
		padding: `${theme.spacing(2)} 0px`,
	}
}))

const SectionContainer = styled(Box)(({ theme }) => ({
	flex: 1,
	display: "flex",
	flexDirection: "row",
	boxShadow: `0px 0px 5px ${theme.palette.common.firstBorder}`,

	"h6, p": {
		color: `${theme.palette.common.firstColor}c0`,
	},
}))

const SettingContent = styled(Box)(({ theme }) => ({
	flex: 1,
	display: "flex",
	flexDirection: "column",
	padding: theme.spacing(3, 3),

	[theme.breakpoints.down("md")]: {
		padding: theme.spacing(2),
	},
}))

const UserInfoSection = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: "row",
	alignItems: "center",
	gap: theme.spacing(3),

	[theme.breakpoints.down('md')]: {
		flexDirection: 'column',
		gap: theme.spacing(2),
	},
}))

const UserAvatar = styled(Box)(({ theme }) => ({
	width: 100,
	height: 100,

	cursor: "pointer",
	overflow: "hidden",
	borderRadius: "50%",
	border: `3px solid ${theme.palette.common.white}`,
	boxShadow: `0px 1px 5px 3px ${theme.palette.common.firstBorder}`,
	transition: 'box-shadow 0.3s ease',

	".MuiAvatar-root, .MuiAvatar-root img": {
		width: "100%",
		height: "100%",
		borderRadius: "50%",
	},

	"&:hover": {
		boxShadow: `0px 1px 5px 2px ${theme.palette.common.firstBorder}`,
	},

	[theme.breakpoints.down("md")]: {
		width: 80,
		height: 80,
	},
}))

export { Settings }